import { Outlet } from 'react-router-dom';
import ItemHeader from './ItemHeader';
import styled from 'styled-components';
import { theme } from '@kvdbil/components';

const Container = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: ${theme.colors.grayscaleToned.light5};
`;

const Content = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  height: 100%;
`;

interface Props {
  previewPageButtonHandler?: () => void;
  title: string;
}

const ItemLayout = ({ previewPageButtonHandler, title }: Props) => {
  return (
    <Container>
      <ItemHeader
        previewPageButtonHandler={previewPageButtonHandler}
        title={title}
      />
      <Content>
        <Outlet />
      </Content>
    </Container>
  );
};

export default ItemLayout;
